import NavBarWithFooterLayout from "../../layouts/navBarWithFooter.layout";
import Page from "./page.makes.page";

const MakesLayout = () => {
  return (
    <NavBarWithFooterLayout>
      <Page />
    </NavBarWithFooterLayout>
  );
};

export default MakesLayout;
